
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.642 0A6.637 6.637 0 000 6.642c0 1.476.72 3.06 1.26 3.942 1.206 2.016 5.004 7.2 5.004 7.2.216.288.54.288.756 0 0 0 3.798-5.184 5.004-7.2.54-.882 1.26-2.466 1.26-3.942A6.637 6.637 0 006.642 0zm0 9.324a2.696 2.696 0 01-2.7-2.7c0-1.494 1.206-2.7 2.7-2.7 1.494 0 2.7 1.206 2.7 2.7 0 1.494-1.206 2.7-2.7 2.7z","fill":"#FFF","fill-rule":"nonzero"}})])
          )
        }
      }
    